module.exports = __webpack_public_path__ + "img/477-1964d6.png";